import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AcceptInvitationStepBase } from '../../shared/accept-invitation-step-base/accept-invitation-step-base';
import { inject } from '@angular/core';
import { Owner } from '../../models/owner.model';
import { ActivatedRoute } from '@angular/router';
import { DataStorageService } from '../../services/data-storage.service';

@Component({
  selector: 'app-additional-owners',
  templateUrl: './additional-owners.component.html',
  styleUrl: './additional-owners.component.scss'
})
export class AdditionalOwnersComponent extends AcceptInvitationStepBase<any> implements OnInit {
  
  public readonly maxOwners: number = 4;

  public addOwner() {
    this.router.navigate(['../additional-owner-info'], { relativeTo: this.route });
  }

  public removeOwner(owner: Owner) {
    this.owners = this.owners.filter((o) => o !== owner);
    this.saveOwnersToStorage();
  }

  public editOwner(owner: Owner) {
    const index = this.owners.findIndex((o) => o.id === owner.id);
    if (index !== -1) {
      this.router.navigate(
        [`../additional-owner-info/${owner.id}`],
        { relativeTo: this.route }
      );
    }
  }

  /**
   * Process an owner by ID - adds to the list if new or updates if existing
   * @param ownerId - The ID of the owner to process
   * @returns - True if owner was processed successfully, false otherwise
   */
  public processOwnerById(ownerId: string): boolean {
    if (!ownerId) return false;
    
    const owner: Owner | null = this.dataStorage.getItem(`owner_${ownerId}`);
    if (!owner) return false;
    
    const index = this.owners.findIndex(o => o.id === ownerId);
    if (index !== -1) {
      // Update existing owner
      this.owners = [...this.owners.slice(0, index), owner, ...this.owners.slice(index + 1)];
    } else {
      // Add new owner
      this.owners = [...this.owners, owner];
    }
    
    this.saveOwnersToStorage();
    return true;
  }

  public override readonly form: FormGroup;
  public override readonly storageKey = 'additionalOwnersForm';
  public override readonly nextUrl = '../link-bank-account';
  public override readonly previousUrl = '../ownership-disclosure';
  public owners: Owner[] = [];
  private readonly dataStorage = inject(DataStorageService);
  private readonly activatedRoute = inject(ActivatedRoute);

  public constructor() {
    super();
    this.form = inject(FormBuilder).group({
      // No fields, as per design (only add owner button)
    });

  }

  private loadOwners() {
    const savedOwners = this.dataStorage.getItem('additionalOwners');
    if (savedOwners && Array.isArray(savedOwners)) {
      this.owners = savedOwners;
    }
  }

  private saveOwnersToStorage() {
    this.dataStorage.setItem('additionalOwners', this.owners);
  }

  public override ngOnInit(): void {
    // Load saved owners
    this.loadOwners();

    // Check if there's an owner coming back from editing screens
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['ownerId']) {
        this.processOwnerById(params['ownerId']);
      }
    });

    // On form changes, persist form data
    this.form.valueChanges.subscribe(() => {
      this.persistFormData();
    });
  }
}
